export default "__VITE_ASSET__CeMTl6ba__"